export default {
  categories: {},
  loadingCategories: false
}
